import React from "react";
import {
  Drawer,
  Typography,
  Table,
  Tag,
} from "antd";
import { bannerTypes, productTypes } from "../../../../types";
import ProductList from "../../../../components/productsList";

const { Text } = Typography;

interface CreateBannerProps {
  showModal: boolean;
  setShowModal: (visible: boolean) => void;
  banner: typeof bannerTypes.banner | undefined;
  setBanner: (banner: typeof bannerTypes.banner | undefined) => void;
  loading: boolean;
}

const DetailsBanner: React.FC<CreateBannerProps> = ({ showModal, setShowModal, banner, setBanner, loading }) => {

  const products = banner?.products

  const onClose = () => {
    setShowModal(false);
    setBanner(undefined);
  }

  const columns = [
    {
      title: "Nombre",
      key: "name",
      render: (row: typeof productTypes.product) => {
        return <Text strong>{row.name}</Text>;
      },
    },
    {
      title: "Descripción",
      key: "description",
      render: (row: typeof productTypes.product) => {
        return <Text strong>{row.description}</Text>;
      },
    },
    {
      title: 'Variantes',
      key: 'variants',
      dataIndex: 'variants',
      render: (variants: typeof productTypes.product['variants']) => {

        const lineItems = variants?.map((p) => ({
          product: {
            _id: p.id,
            img: p.img,
            title: p.title,
            description: p.description,
            product: {
              name: p.product.name,
              description: p.product.description,
            },
          },
        })) ?? [];

        if(lineItems.length > 0){
          return <ProductList lineItems={lineItems} />;
        } else {
          return <Tag color="yellow">Sin Productos</Tag>
        }
      },
    },
  ];

  return (
    <Drawer
      title="Productos"
      open={showModal}
      onClose={onClose}
      width={"50%"}
    >
      <div style={{ marginTop: 10 }}>
        <Table<typeof productTypes.product>
          dataSource={products}
          rowKey="id"
          loading={loading}
          columns={columns}
        />
      </div>
    </Drawer>
  );
};

export default DetailsBanner;
